export class LoadingScreenManager {
  constructor({
    className = '.c-loading-screen',
    logoClassName = '.c-loading-screen__logo',
    screenFadeOutDuration = '0.7s',
    screenFadeOutPauseDuration = '0.2s',
    logoFadeInDuration = '0.7s',
    logoFadeOutDuration = '0.7s',
    logoFadeInPauseDuration = '1s',
    logoFadeOutPauseDuration = '.2s',
    developmentMode = false
  } = {}) {
    this.className = className;
    this.logoClassName = logoClassName;
    this.screenFadeOutDuration = screenFadeOutDuration;
    this.screenFadeOutPauseDuration = screenFadeOutPauseDuration;
    this.logoFadeInDuration = logoFadeInDuration;
    this.logoFadeOutDuration = logoFadeOutDuration;
    this.logoFadeInPauseDuration = logoFadeInPauseDuration;
    this.logoFadeOutPauseDuration = logoFadeOutPauseDuration;
    this.developmentMode = developmentMode;
    this.loadingElement = document.querySelector(className);
    this.logoElement = document.querySelector(logoClassName);

    if (!this.loadingElement || !this.logoElement) {
      return;
    }

    this.init();
  }

  init() {
    this.setDuration();

    if (!sessionStorage.getItem('loadingShown') || this.developmentMode) {
      this.showLoadingScreen();
    } else {
      this.logoElement.classList.add('is-show');
      this.removeLoadingScreen();
    }
  }

  setDuration() {
    const prefix = '--loading-';
    document.documentElement.style.setProperty(`${prefix}screen-fade-out-duration`, this.screenFadeOutDuration);
    document.documentElement.style.setProperty(`${prefix}screen-fade-out-pause-duration`, this.screenFadeOutPauseDuration);
    document.documentElement.style.setProperty(`${prefix}logo-fade-in-duration`, this.logoFadeInDuration);
    document.documentElement.style.setProperty(`${prefix}logo-fade-out-duration`, this.logoFadeOutDuration);
    document.documentElement.style.setProperty(`${prefix}logo-fade-in-pause-duration`, this.logoFadeInPauseDuration);
    document.documentElement.style.setProperty(`${prefix}logo-fade-out-pause-duration`, this.logoFadeOutPauseDuration);
  }

  wait(time) {
    let ms = time;
    if (typeof time === 'string' && time.endsWith('s')) {
      ms = parseFloat(time) * 1000;
    }

    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async showLoadingScreen() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    this.logoElement.classList.add('is-fade-in');
    await this.wait(this.logoFadeInDuration);

    // ロゴのフェードイン後に一定時間待つ
    await this.wait(this.logoFadeInPauseDuration);

    this.fadeOutLogo();
  }

  async fadeOutLogo() {
    this.logoElement.classList.add('is-fade-out');
    this.logoElement.addEventListener('animationend', async () => {
      await this.wait(this.logoFadeOutPauseDuration);

      this.fadeOutScreen();
    });
  }

  async fadeOutScreen() {
    this.loadingElement.classList.add('is-fade-out');
    this.loadingElement.addEventListener('animationend', async () => {
      this.removeLoadingScreen();

      // 最後まで到達したらローカルストレージにフラグを立てる
      sessionStorage.setItem('loadingShown', 'true');
    });
  }

  async removeLoadingScreen() {
    await this.wait(this.screenFadeOutPauseDuration);
    document.body.classList.add('is-removed-loading-screen');
    document.body.removeChild(this.loadingElement);
  }
}
